<div class="app flex-row align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="clearfix">
          <h1 class="float-left display-3 mr-4">500</h1>
          <h4 class="pt-3">Houston, we have a problem!</h4>
          <p class="text-muted">The page you are looking for is temporarily unavailable.</p>
        </div>
        <div class="input-prepend input-group">
            <div class="col-6 col-sm-4 col-md mb-3 mb-xl-0 text-center">
              <a  [routerLink]="['']" class="btn btn-primary btn-lg" type="button">
                <i class="fa fa-arrow-left"></i>&nbsp;Go to Home</a>
              </div>
          </div>
      </div>
    </div>
  </div>
</div>
